
import { IPullRequestAdornmentService } from "VC/Pullrequest/Common/PullRequestAdornmentService";
import { getGlobalPageContext } from "VersionControl/Scenarios/Shared/EnsurePageContext";
import { ExtensionService } from "VSS/Contributions/Services";
import { IVssContributionService } from "VSS/Platform/Contribution";
import * as Service from "VSS/Service";

/**
 * Pull Request Gutter Adornment source
 */

export class DiffViewerExtensionSource {
    private readonly PRFileAdornmentContributionId: string = "ms.vss-code-web.content-pr-file-adornment";
    private readonly CcPrFileAdornmentServiceContributionId: string = "ms.vss-codecoverage-web.codecoverage-pr";

    public async fetchExtensionContributions(): Promise<IPullRequestAdornmentService[]> {
        const contributionService = Service.getService(ExtensionService);
        return contributionService.getContributionsForTarget(this.PRFileAdornmentContributionId).then(contributions => {

            const contributionList: Promise<IPullRequestAdornmentService>[] = [];
            for (const contribution of contributions) {

                // Restrict to only code coverage for now
                // once we have a scenario for other extensions remove this check
                // and enable selection of appropriate extension
                if (contribution.id === this.CcPrFileAdornmentServiceContributionId) {
                    const service = getGlobalPageContext().getService<IVssContributionService>("IVssContributionService");
                    contributionList.push(service.getService<IPullRequestAdornmentService>(contribution.id, false));
                }
            }

            return Promise.all(contributionList);
        });
    }
}